import { CareerPlanLevel, CareerPlanSkill } from '../../models/career-plans';

export class SetSkill {
  static readonly type = '[Career plans] - Set skill';

  constructor(public skill?: CareerPlanSkill) {}
}

export class SetLevel {
  static readonly type = '[Career plans] - Set level';

  constructor(public level?: CareerPlanLevel) {}
}
